import './RuleSearch.scss'
import { useRuleSearchController } from './RuleSearchController';
import RuleSearchCard from '../ruleSearchCard/RuleSearchCard';
import Pager from '../pager/Pager';
// import RuleSearchFacets from '../ruleSearchFacets/RuleSearchFacets';
import { Loader } from '@progress/kendo-react-indicators';
import CustomDialog from '../../stateless/dialog/CustomDialog';
import HtmlRender from '../../stateless/htmlRender/HtmlRender';
import CustomButton from '../../stateless/customButton/CustomButton';
import { PDFExport } from "@progress/kendo-react-pdf";

interface ISearchProps {
    id: string;
}

export const RuleSearch = (props: ISearchProps) => {
    const {
        // variables and state
        query,
        results,
        suggestions,
        pageCount,
        loading,
        titleDialogOpen,
        titleData,
        pdfExport,
        chapterDialogOpen,
        selectedChapterHtml,
        selectedChapter,
        // functions
        handleChange,
        handleSuggestionClick,
        search,
        toggleTitleDialog,
        toggleChapterDialog,
        handlePageChange,
        exportPDF,
        getHighlights,
    } = useRuleSearchController();

    return (
        <div className={"main-wrapper"}>
            {titleDialogOpen ? (
                <CustomDialog size="large" open={titleDialogOpen} title={'Title'} toggleDialog={toggleTitleDialog} hideButtons>

                    <div className="dialog-content">
                        {titleData.length > 1 ? (
                            <div className="download-pdf-button">
                                <CustomButton
                                    onClick={exportPDF}
                                    icon="pdf"
                                    themeColor="success"
                                >
                                    Download PDF
                                </CustomButton>
                            </div>
                        ) : null}
                        <PDFExport
                            ref={pdfExport}
                            margin={40}
                            fileName={`Title-${new Date().toLocaleDateString()}`}
                            author="NE-Rules"
                            paperSize="A4"
                            scale={0.6}
                        >
                            {
                                titleData.filter((x: any) => x.chapterHtml !== null).length > 1 ? (
                                    titleData.filter((x: any) => x.chapterHtml !== null).map((chapter: any, index: number) => {
                                        return (
                                            <HtmlRender key={index + chapter.id} value={chapter.chapterHtml} />
                                        )
                                    })
                                ) : (
                                    <div className="loading-search">
                                        <div>Loading Title. This may take some time</div>
                                        <Loader type="infinite-spinner" />
                                    </div>
                                )
                            }
                        </PDFExport>
                    </div>
                </CustomDialog>
            ) : null}
            {chapterDialogOpen ? (
                <CustomDialog size="large" open={chapterDialogOpen} title={'Chapter'} toggleDialog={toggleChapterDialog} hideButtons>

                    <div className="dialog-content">
                        <div className="download-pdf-button">
                            <CustomButton
                                onClick={exportPDF}
                                icon="pdf"
                                themeColor="success"
                            >
                                Download PDF
                            </CustomButton>
                        </div>
                        <PDFExport
                            ref={pdfExport}
                            margin={40}
                            fileName={`Title-${selectedChapter.TitleNumber}-Chapter-${selectedChapter.ChapterNumber}-${new Date().toLocaleDateString()}`}
                            author="NE-Rules"
                            paperSize="A4"
                            scale={0.6}
                        >
                            <HtmlRender value={selectedChapterHtml} />
                        </PDFExport>
                    </div>
                </CustomDialog>
            ) : null}
            <div className={"page code-search-page"}>
                <div className={"content code-search-bar"}>
                    <h3 className="search-header">Rules and Regulations Search</h3>
                    <form className="search-form" onSubmit={search}>
                        <div className="search-box">
                            <input
                                id="search-input"
                                type="search"
                                value={query}
                                onChange={handleChange}
                                placeholder="Search"
                                className="search-input"
                                autoComplete="off"
                            />
                            {suggestions ? (
                                <div className="arrow-up hide"></div>
                            ) : null}
                            <div className='suggestion-box hide'>
                                {suggestions ? suggestions.map((suggest: any, index: number) => {
                                    return (
                                        <div key={suggest + index} className='suggestion' onClick={() => { handleSuggestionClick(suggest) }}>{suggest}</div>
                                    )
                                }) : null}
                            </div>
                        </div>
                        <div style={{ "margin": "0px", "padding": "0px" }}>
                            <CustomButton size="small" themeColor="warning" onClick={search} icon="search">Search</CustomButton>
                        </div>
                    </form>
                </div>
                {results && query ? (
                    <>
                        {!loading ? (
                            results.length === 0
                            ?   <div className="search-result-placeholder"><h4>No Results Found</h4></div>
                            :   <div className="search-results">
                                    {results.map((resultData: any, index: number) => {
                                        let updatedSearchData = getHighlights(resultData);
                                        return (
                                            <RuleSearchCard
                                                key={index}
                                                searchData={updatedSearchData}
                                                toggleTitleDialog={toggleTitleDialog}
                                                toggleChapterDialog={toggleChapterDialog}
                                            />
                                        )
                                    })}
                                </div>
                        ) : (
                            <div className="loading-search">
                                <Loader type="converging-spinner" size="large" />
                            </div>
                        )}

                        {pageCount !== 0
                            ? (
                            <div className="pager">
                                <Pager total={pageCount ?? 0} handlePageChange={handlePageChange} />
                            </div>)
                            : null}
                    </>
                ) : (<div className="search-result-placeholder"><h4>No Results Found</h4></div>)}
            </div>
        </div>
    )
}
